<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { getQueryString } from '@/utils/util'
import { setCookie, removeCookie } from '@/utils/auth'
export default {
  name: 'App',
  created () {
    try {
      if (getQueryString('openId')) {
        setCookie('openId', getQueryString('openId'))
      } else {
        removeCookie('openId')
      }
      if (getQueryString('userid')) {
        setCookie('phone', getQueryString('phone'))
        setCookie('userid', getQueryString('userid'))
        setCookie('head', getQueryString('head'))
        setCookie('name', getQueryString('name'))
        setCookie('accessToken', getQueryString('accessToken'))
        setCookie('effective', getQueryString('effective'))
      }
      if (getQueryString('env')) {
        setCookie('env', getQueryString('env'))
      }
    } catch (error) {
    }
  }
}
</script>

<style lang="scss">
#app, body, html {
  height: 100%;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue